import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/cone.svg
 */
const IconCone: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12.002 24c1.103 0 10.675-.083 10.949-2.954V20.813a1.419 1.419 0 00-.376-.84L12.663.398A.75.75 0 0012 0a.753.753 0 00-.662.398L1.424 19.973a1.43 1.43 0 00-.375.84V21.046C1.323 23.913 10.895 24 12.002 24zm0-21.62L20.3 18.772a37.473 37.473 0 00-16.602 0l8.303-16.39zM2.618 20.924l.052-.101a29.894 29.894 0 0118.674 0l.053.1v.037a29.251 29.251 0 01-18.816 0l.037-.036z"
      fill="currentColor"
    />
  </svg>
);

export default IconCone;
